// Paleta de cores por atividade, usada em toda tela que mostra uma grade de
// turmas (Grade.js, GradeTurmas.js) — cada nome de atividade sempre cai na
// mesma cor (hash simples do nome), então a mesma turma fica visualmente
// consistente em telas diferentes. Extraído daqui em vez de duplicado em cada
// arquivo pra dark mode (e qualquer ajuste de paleta) ser feito num lugar só.
const CORES_ATIVIDADE = [
  {
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    text: 'text-blue-700 dark:text-blue-400',
    border: 'border-blue-100 dark:border-blue-900/40',
  },
  {
    bg: 'bg-green-50 dark:bg-green-900/20',
    text: 'text-green-700 dark:text-green-400',
    border: 'border-green-100 dark:border-green-900/40',
  },
  {
    bg: 'bg-amber-50 dark:bg-amber-900/20',
    text: 'text-amber-700 dark:text-amber-400',
    border: 'border-amber-100 dark:border-amber-900/40',
  },
  {
    bg: 'bg-purple-50 dark:bg-purple-900/20',
    text: 'text-purple-700 dark:text-purple-400',
    border: 'border-purple-100 dark:border-purple-900/40',
  },
  {
    bg: 'bg-pink-50 dark:bg-pink-900/20',
    text: 'text-pink-700 dark:text-pink-400',
    border: 'border-pink-100 dark:border-pink-900/40',
  },
  {
    bg: 'bg-cyan-50 dark:bg-cyan-900/20',
    text: 'text-cyan-700 dark:text-cyan-400',
    border: 'border-cyan-100 dark:border-cyan-900/40',
  },
];

export const corDaAtividade = (nome) => {
  let hash = 0;
  for (let i = 0; i < (nome || '').length; i++) hash = (hash * 31 + nome.charCodeAt(i)) >>> 0;
  return CORES_ATIVIDADE[hash % CORES_ATIVIDADE.length];
};
